import {types as actions, errorReportAction} from '../../reducers/actions';


const handleErrors = store => next=> action=>{
  try {
    if(action.type === actions.ERROR){
      store.dispatch(errorReportAction(action.payload, action.source));
    }  
    next(action);
  } catch(e) { }
}

export default handleErrors;


// WEBPACK FOOTER //
// ./src/utils/middleware/reportError.js